import * as React from "react";
import { cellTypeToDetails } from "../utils";
import { CellType } from "../apis/api";
import {
    GridArrowData,
    HighlightableLetterData,
    PlayableLetterData,
    UIStateAction,
} from "./UIState";
import { Letter } from "./Letter";
import { TileSlot } from "./TileSlot";
import { Arrow } from "./Arrow";

export function Grid(props: {
    cellTypes: CellType[];
    playerLetters: Array<PlayableLetterData>;
    boardLetters: HighlightableLetterData[];
    uiDispatch: (x: UIStateAction) => void;
    arrow: GridArrowData;
}) {
    const elements = props.cellTypes.map((ct, i) => {
        const { className, text } = cellTypeToDetails(ct);

        let tileElement: React.JSX.Element;
        if (props.boardLetters[i] != null) {
            tileElement = <Letter data={props.boardLetters[i]} />;
        } else {
            tileElement = (
                <>
                    <span>{text}</span>
                    <TileSlot
                        location={{ location: "GRID", index: i }}
                        uiDispatch={props.uiDispatch}
                    />
                </>
            );
        }

        let arrowElement: React.JSX.Element;
        if (props.arrow != null && props.arrow.position == i) {
            arrowElement = <Arrow data={props.arrow} />;
        }

        return (
            <div key={i} className={"grid-spot " + className}>
                {tileElement}
                {arrowElement}
            </div>
        );
    });

    props.playerLetters.forEach((letter) => {
        if (letter != null && letter.grid_index != null) {
            const ct = props.cellTypes[letter.grid_index];
            const { className } = cellTypeToDetails(ct);

            elements[letter.grid_index] = (
                <div
                    key={"letter" + letter.grid_index}
                    className={"grid-spot " + className}
                >
                    <TileSlot
                        tile={
                            <Letter
                                data={{ ...letter, highlight: false }}
                                letterUpdater={(value) => {
                                    props.uiDispatch({
                                        $type: "SET_BLANK_LETTER",
                                        index: letter.tray_index,
                                        value: value,
                                    });
                                }}
                            />
                        }
                        location={{
                            location: "GRID",
                            index: letter.grid_index,
                        }}
                        uiDispatch={props.uiDispatch}
                    />
                </div>
            );
        }
    });

    return <div className="board-grid">{elements}</div>;
}
